export const SALEOR_AUTH_PLUGIN_ID = "_saleorAuthPluginId";
export const SALEOR_REFRESH_TOKEN = "_saleorRefreshToken";
